/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_timer_label_1hour = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 Hour`)
};

const es_timer_label_1hour = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 hora`)
};

const de_timer_label_1hour = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 Stunde`)
};

const nl_timer_label_1hour = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 uur`)
};

const fr_timer_label_1hour = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 heure`)
};

const it_timer_label_1hour = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 ora`)
};

const pt_br2_timer_label_1hour = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 hora`)
};

const pt_timer_label_1hour = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 hora`)
};

const ja_timer_label_1hour = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1時間`)
};

const zh_timer_label_1hour = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1小时`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const timer_label_1hour = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.timer_label_1hour(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("timer_label_1hour", locale)
	if (locale === "en") return en_timer_label_1hour(inputs)
	if (locale === "es") return es_timer_label_1hour(inputs)
	if (locale === "de") return de_timer_label_1hour(inputs)
	if (locale === "nl") return nl_timer_label_1hour(inputs)
	if (locale === "fr") return fr_timer_label_1hour(inputs)
	if (locale === "it") return it_timer_label_1hour(inputs)
	if (locale === "pt-BR") return pt_br2_timer_label_1hour(inputs)
	if (locale === "pt") return pt_timer_label_1hour(inputs)
	if (locale === "ja") return ja_timer_label_1hour(inputs)
	return zh_timer_label_1hour(inputs)
};